import { Routes } from '@angular/router';
import { AdministrationUsersComponent } from './Components/administration-users/administration-users.component';
import { AllProductsComponent } from './Components/all-products/all-products.component';
import { DashboardComponent } from './Components/dashboard/dashboard.component';
import { DobuleFactorComponent } from './Components/dobule-factor/dobule-factor.component';
import { ForgotPasswordComponent } from './Components/forgot-password/forgot-password.component';
import { IframeComponent } from './Components/iframe/iframe.component';
import { ListDoubleFactorComponent } from './Components/list-double-factor/list-double-factor.component';
import { ListEnterpriseComponent } from './Components/list-enterprise/list-enterprise.component';
import { LoginExternoComponent } from './Components/login-externo/login-externo.component';
import { LoginComponent } from './Components/login/login.component';
import { MainComponent } from './Components/main/main.component';
import { ModalListaEmpresasComponent } from './Components/modal-lista-empresas/modal-lista-empresas.component';
import { PasswordChangedComponent } from './Components/password-changed/password-changed.component';
import { ProductAccessComponent } from './Components/product-access/product-access.component';
import { RegisterErpComponent } from './Components/register-erp/register-erp.component';
import { UserInfoComponent } from './Components/user-info/user-info.component';
import { WarningComponent } from './Components/warning/warning.component';
import { SessionGuard } from './Guard';
import Rutas from './Models/Base/rutas';

export const routes: Routes = [
  {
    path: '',
    component: MainComponent,
    canActivate: [SessionGuard],
    data: {
      breadcrumbs: ['Portal Defontana', 'Dashboard']
    },
    children: [
      {
        path: Rutas.DASHBOARD,
        component: DashboardComponent,
        canActivate: [SessionGuard]
      },
      {
        path: Rutas.PRODUCTS,
        component: AllProductsComponent,
        canActivate: [SessionGuard],
        data: { breadcrumbs: ['Productos y servicios'] }
      },
      {
        path: Rutas.ADMINISTRATION,
        component: AdministrationUsersComponent,
        canActivate: [SessionGuard],
        data: { breadcrumbs: ['Administración'] }
      },
      {
        path: Rutas.MY_ACCOUNT,
        component: UserInfoComponent,
        canActivate: [SessionGuard],
        data: { breadcrumbs: ['Mis Datos'] }
      },
      {
        path: Rutas.MY_COMPANIES,
        component: ListEnterpriseComponent,
        canActivate: [SessionGuard],
        data: { breadcrumbs: ['Mis Empresas'] }
      },
      {
        path: Rutas.DOUBLE_FACTOR_LIST,
        component: ListDoubleFactorComponent,
        canActivate: [SessionGuard],
        data: { breadcrumbs: ['Autenticación en dos pasos'] }
      },
      {
        path: Rutas.CHANGE_PASSWORD,
        component: PasswordChangedComponent,
        canActivate: [SessionGuard],
        data: { breadcrumbs: ['Cambio de contraseña'] }
      },
      {
        path: Rutas.LIST_COMPANIES,
        component: ModalListaEmpresasComponent,
        canActivate: [SessionGuard],
        data: { breadcrumbs: ['Listado de empresas'] }
      },
      {
        path: Rutas.SERVICE,
        component: IframeComponent,
        canActivate: [SessionGuard],
        loadChildren: () => import('./iframe-routing.module').then(m => m.IframeRoutingModule)
      },
      {
        path: '',
        pathMatch: 'prefix',
        redirectTo: Rutas.DASHBOARD
      },
      {
        path: Rutas.PRODUCT_ACCESS,
        component: ProductAccessComponent,
        canActivate: [SessionGuard],
        data: { breadcrumbs: ['Configuraciones'] }
      }
    ]
  },
  { path: Rutas.LOGIN, component: LoginComponent },
  { path: Rutas.ERP_REGISTER, component: RegisterErpComponent },
  { path: Rutas.DOUBLE_FACTOR, component: DobuleFactorComponent },
  { path: 'loginExt/:email/:pass', component: LoginExternoComponent },
  { path: 'loginExt/:email/:pass/:id_prod', component: LoginExternoComponent },
  { path: 'login/product/:ReturnProduct', component: LoginComponent },
  { path: Rutas.FORGOT_PASSWORD, component: ForgotPasswordComponent },
  {
    path: Rutas.EXPIRATION,
    component: WarningComponent,
    data: {
      info: {
        title: 'Estamos mejorando la seguridad de tu cuenta. Tu contraseña actual ha expirado y debe ser cambiada cada 3 meses',
        subtitle: 'Por favor, ingresar una nueva contraseña',
        action: [{ id: 1, label: 'Ok' }]
      }
    }
  },
  {
    path: Rutas.BLOCKED,
    component: WarningComponent,
    data: {
      info: {
        title: 'Haz superado el máximo de intentos para iniciar sesión y tu cuenta ha sido bloqueada.',
        subtitle: 'Para desbloquearla debes seguir el proceso de recuperación de contraseña.',
        action: [
          { id: 2, label: 'Recuperar contraseña' },
          { id: 0, label: 'Volver' }
        ]
      }
    }
  },
  {
    path: Rutas.ASSOCIATION,
    component: WarningComponent,
    data: {
      info: {
        title: 'Actualmente tu cuenta no posee empresas asociadas. Por favor contacta al administrador para que asigne tu email a un usuario de la cuenta',
        action: [{ id: 4, label: 'Cerrar sesión' }]
      }
    }
  }
];
